import DeviceElevatorIntegrationModal from './DeviceElevatorIntegrationModal';

export default DeviceElevatorIntegrationModal;
